import React from 'react'
import { Container, Row, Col, Badge, Card } from 'react-bootstrap';
import { motion } from "motion/react";
import servicesData from "../../data/servicesData.json";

const CaseStudy = () => {
    const getImage = (imageName) => {
        return require(`../../assets/${imageName}`)
    }

    const { caseStudy } = servicesData

    const contentVariants = {
        hidden: { opacity: 0, x: -50 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    }

    const imageVariants = {
        hidden: { opacity: 0, x: 50 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    }

    const badgeVariants = {
        hidden: { opacity: 0, scale: 0.8 },
        visible: (index) => ({
            opacity: 1,
            scale: 1,
            transition: { duration: 0.4, delay: index * 0.1 }
        })
    }

    const listVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: (index) => ({
            opacity: 1,
            x: 0,
            transition: { duration: 0.4, delay: index * 0.15 + 0.3 }
        })
    }

    return (
        <section className="section-lg bg-primary overflow-hidden" id="growth-case-study">
            <Container>
                <Row className="align-items-center g-4">
                    <Col lg={6} xs={12}>
                        <motion.div className="text-lg-start text-center"
                            variants={contentVariants}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.3 }}
                        >
                            <div className="d-inline-flex align-items-center gap-2 mb-3">
                                {caseStudy.badges.map((badge, index) => (
                                    <motion.div
                                        key={index}
                                        variants={badgeVariants}
                                        initial="hidden"
                                        whileInView="visible"
                                        viewport={{ once: true }}
                                        custom={index}
                                        whileHover={{ scale: 1.1 }}
                                    >
                                        <Badge pill bg={badge.variant} text={badge.textColor} className="py-2 px-3">{badge.text}</Badge>
                                    </motion.div>
                                ))}
                            </div>
                            <motion.h2 className="text-success mb-2"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.3, duration: 0.5 }}
                            >
                                {caseStudy.title}
                            </motion.h2>
                            <motion.p className="text-light mb-4"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.4, duration: 0.5 }}
                            >
                                {caseStudy.description}
                            </motion.p>

                            <ul className="list-unstyled text-start d-inline-block mb-4 lh-lg">
                                {caseStudy.highlights.map((highlight, index) => (
                                    <motion.li key={index} className="d-flex align-items-center text-light"
                                        variants={listVariants}
                                        initial="hidden"
                                        whileInView="visible"
                                        viewport={{ once: true }}
                                        custom={index}
                                    >
                                        <i className="ri-checkbox-circle-line me-2"></i> {highlight}
                                    </motion.li>
                                ))}
                            </ul>

                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.7, duration: 0.5 }}
                                whileHover={{ scale: 1.02 }}
                            >
                                <Card className="bg-white bg-opacity-50 border-0 shadow-sm mb-3">
                                    <Card.Body>
                                        <div className="d-flex align-items-start">
                                            <i className="ri-chat-quote-line text-primary fs-4 me-2"></i>
                                            <p className="mb-0 text-primary">
                                                "{caseStudy.quote}"
                                                <span className="text-dark fw-semibold"> — {caseStudy.author}</span>
                                            </p>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </motion.div>
                    </Col>
                    <Col lg={6} xs={12}>
                        <motion.div className="ratio ratio-16x9 rounded-4 overflow-hidden shadow-sm"
                            variants={imageVariants}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.3 }}
                            whileHover={{ scale: 1.03, transition: { duration: 0.3 } }}
                        >
                            <img src={getImage(caseStudy.image)} alt="Case Study" className="w-100 h-100 object-fit-cover" />
                        </motion.div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default CaseStudy;
